var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "text-field",
    _vm._b(
      {
        attrs: {
          value: _vm.valueModel,
          "mask-type": "can-sin",
          disabled: _vm.disableInput,
          label: _vm.label,
          "hidden-label": _vm.hiddenLabel,
        },
        on: {
          "update:value": function ($event) {
            _vm.valueModel = $event
          },
          change: _vm.handleChange,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "label",
              fn: function () {
                return [_vm._t("label")]
              },
              proxy: true,
            },
            {
              key: "prepend-input",
              fn: function () {
                return [_vm._t("prepend-input")]
              },
              proxy: true,
            },
            {
              key: "append-input",
              fn: function () {
                return [
                  _vm._t("append-input"),
                  _vm._v(" "),
                  _vm.showSinToggle
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "link", disabled: _vm.loading },
                          on: { click: _vm.toggleFullSIN },
                        },
                        [
                          _vm.loading
                            ? _c("div", {
                                staticClass: "ld ld-ring ld-spin-fast mini",
                              })
                            : _c("icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.top",
                                    value: {
                                      title: _vm.sinTooltipTile,
                                      disabled: _vm.loading,
                                    },
                                    expression:
                                      "{\n          title: sinTooltipTile,\n          disabled: loading\n        }",
                                    modifiers: { top: true },
                                  },
                                ],
                                staticClass: "show-sin text-primary clickable",
                                attrs: { name: _vm.showSinIconName },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "before-input",
              fn: function () {
                return [_vm._t("before-input")]
              },
              proxy: true,
            },
            {
              key: "after-input",
              fn: function () {
                return [_vm._t("after-input")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "text-field",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }